export const ApplicationConstant = {
    ApplicationID : 17,
    clientId : 11,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
